import {createBrowserRouter, redirect, Navigate} from "react-router-dom";
import Container from "components/layout/container";
import ErrorBoundary from "components/layout/router-error-boundary";
import * as Pages from "components/pages";

export default function createRouter(initialState) {
  const {pages, user} = initialState;
  const requireAdmin = () => {
    if(!user) return redirect("/subscribe");
    if(!user.admin) return redirect("/profile");

    return null;
  };
  const requireNoUser = () => {
    if(user) return redirect("/profile");

    return null;
  };
  const requireUser = () => {
    if(!user) return redirect("/subscribe");

    return null;
  };
  const staticPages = pages.map(({path}) => (
    {Component: Pages.Public.Template, path: `/${path}`}
  ));

  return createBrowserRouter(
    [{
      children: [
        ...[
          {Component: Pages.Public.Template, path: "/"},
          {Component: Pages.Public.Ads, path: "/ads"},
          {Component: Pages.Public.CaseSubmissions.New, path: "/cases/submissions"},
          {Component: Pages.Public.Cases.Show, path: "/cases/:uid"},
          {Component: Pages.Public.Citations, path: "/citations"},
          {Component: Pages.Public.Disclaimer, path: "/disclaimer"},
          {Component: Pages.Public.Episodes.Show, path: "/episodes/:uid"},
          {Component: Pages.Public.Newsletters.Show, path: "/newsletters/:uid"},
          {Component: Pages.Public.Posts.Show, path: "/posts/:uid"}
        ].map((route) => ({
          children: [route],
          path: route.path,
          Component: Pages.Public.Container
        })),
        {
          children: [
            {Component: Pages.Public.Store.Cart, path: "/store/cart"},
            {Component: Pages.Public.Store.Order, path: "/store/order"},
            {Component: Pages.Public.Store.Show, path: "/store"}
          ],
          path: "/store",
          Component: Pages.Public.Store.Container
        },
        ...[
          {Component: Pages.Public.User.Profile, loader: requireUser, path: "/profile"},
          {Component: Pages.Public.User.Session, loader: requireNoUser, path: "/session"}
        ].map((route) => ({
          children: [route],
          path: route.path,
          Component: Pages.Public.User.Container
        })),
        {element: <Navigate to="/admin/messages" />, loader: requireAdmin, path: "/admin"},
        {
          children: [
            {Component: Pages.Admin.ArticleCategories.New, path: "/admin/article-categories/new"},
            {Component: Pages.Admin.ArticleCategories.Edit, path: "/admin/article-categories/:id"},
            {Component: Pages.Admin.ArticleCategories.List, path: "/admin/article-categories"},
            {Component: Pages.Admin.Articles.New, path: "/admin/articles/new"},
            {Component: Pages.Admin.Articles.Edit, path: "/admin/articles/:id"},
            {Component: Pages.Admin.Articles.List, path: "/admin/articles"},
            {Component: Pages.Admin.Authors.New, path: "/admin/authors/new"},
            {Component: Pages.Admin.Authors.Edit, path: "/admin/authors/:id"},
            {Component: Pages.Admin.Authors.List, path: "/admin/authors"},
            {Component: Pages.Admin.CaseSubmissions.List, path: "/admin/case-submissions"},
            {Component: Pages.Admin.CaseSubmissions.Show, path: "/admin/case-submissions/:id"},
            {Component: Pages.Admin.Cases.New, path: "/admin/cases/new"},
            {Component: Pages.Admin.Cases.Edit, path: "/admin/cases/:uid"},
            {Component: Pages.Admin.Cases.List, path: "/admin/cases"},
            {Component: Pages.Admin.Channels.New, path: "/admin/channels/new"},
            {Component: Pages.Admin.Channels.Edit, path: "/admin/channels/:uid"},
            {Component: Pages.Admin.Channels.List, path: "/admin/channels"},
            {Component: Pages.Admin.Episodes.New, path: "/admin/episodes/new"},
            {Component: Pages.Admin.Episodes.Edit, path: "/admin/episodes/:uid"},
            {Component: Pages.Admin.Episodes.List, path: "/admin/episodes"},
            {Component: Pages.Admin.Messages.Show, path: "/admin/messages/:id"},
            {Component: Pages.Admin.Messages.List, path: "/admin/messages"},
            {Component: Pages.Admin.Newsletters.New, path: "/admin/newsletters/new"},
            {Component: Pages.Admin.Newsletters.Edit, path: "/admin/newsletters/:uid"},
            {Component: Pages.Admin.Newsletters.List, path: "/admin/newsletters"},
            {Component: Pages.Admin.Orders.Show, path: "/admin/orders/:id"},
            {Component: Pages.Admin.Orders.List, path: "/admin/orders"},
            {Component: Pages.Admin.Pages.New, path: "/admin/pages/new"},
            {Component: Pages.Admin.Pages.Edit, path: "/admin/pages/:id"},
            {Component: Pages.Admin.Pages.List, path: "/admin/pages"},
            {Component: Pages.Admin.Posts.New, path: "/admin/posts/new"},
            {Component: Pages.Admin.Posts.Edit, path: "/admin/posts/:uid"},
            {Component: Pages.Admin.Posts.List, path: "/admin/posts"},
            {Component: Pages.Admin.Products.Edit, path: "/admin/products/:id"},
            {Component: Pages.Admin.Products.List, path: "/admin/products"},
            {Component: Pages.Admin.Reviewers.New, path: "/admin/reviewers/new"},
            {Component: Pages.Admin.Reviewers.Edit, path: "/admin/reviewers/:id"},
            {Component: Pages.Admin.Reviewers.List, path: "/admin/reviewers"},
            {Component: Pages.Admin.Sections.Edit, path: "/admin/sections/:id"},
            {Component: Pages.Admin.Sections.List, path: "/admin/sections"},
            {Component: Pages.Admin.Stats.List, path: "/admin/stats"},
            {Component: Pages.Admin.Uploads.List, path: "/admin/uploads"},
            {Component: Pages.Admin.Users.Edit, path: "/admin/users/:id"},
            {Component: Pages.Admin.Users.List, path: "/admin/users"}
          ].map((route) => ({...route, loader: requireAdmin})),
          path: "/admin",
          Component: Pages.Admin.Container
        },
        {element: <Navigate to="/preview/episodes" />, loader: requireAdmin, path: "/preview"},
        {
          children: [
            {Component: Pages.Preview.Cases.Show, path: "/preview/cases/:uid"},
            {Component: Pages.Preview.Cases.List, path: "/preview/cases"},
            {Component: Pages.Preview.Episodes.Show, path: "/preview/episodes/:uid"},
            {Component: Pages.Preview.Episodes.List, path: "/preview/episodes"},
            {Component: Pages.Preview.Newsletters.Show, path: "/preview/newsletters/:uid"},
            {Component: Pages.Preview.Posts.Show, path: "/preview/posts/:uid"},
            {Component: Pages.Preview.Posts.List, path: "/preview/posts"}
          ].map((route) => ({...route, loader: requireAdmin})),
          path: "/preview",
          Component: Pages.Preview.Container
        },
        ...staticPages,
        {Component: Pages.NotFound}
      ],
      Component: Container,
      ErrorBoundary
    }]
  );
}
